import { useContext } from 'react';
import axios from 'axios';
import ApiClientFactoryContext from './ApiClientFactoryContext';
import { ApiClientFactory } from '../ApiClientFactory';

export default function useApiClientFactory(): ApiClientFactory {
  const { factory } = useContext(ApiClientFactoryContext);
  return factory ?? axios.create;
}
